var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._v("\n  " + _vm._s(_vm.$t("kanbanCardActivity")) + "\n  "),
      _vm.isBoardNotInSelectedAccount
        ? _c("div", { staticClass: "small text-muted" }, [
            _vm._v(_vm._s(_vm.$t("workflow.card.activityInDifferentAccount")))
          ])
        : _c("vSelect", {
            attrs: {
              options: _vm.activitiesForVSelect,
              label: "name",
              reduce: e => e.id,
              cleanable: true,
              appendToBody: true,
              "calculate-position": _vm.vSelectInModalWithPopper
            },
            model: {
              value: _vm.activityId,
              callback: function($$v) {
                _vm.activityId = $$v
              },
              expression: "activityId"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }